<template>
  <div class="absolute inset-0 pointer-events-none">
    <!-- Top-left triangle -->
    <Motion
      tag="div"
      class="absolute top-0 left-0"
      :style="{ width: '8px', height: '8px' }"
      :initial="false"
      :animate="{
        x: isHovered ? -move : 0,
        y: isHovered ? -move : 0,
      }"
      :transition="{ type: 'spring', stiffness: 400, damping: 24 }"
    >
      <svg
        width="8"
        height="8"
        class="fill-background"
        aria-label="Top-left triangle"
      >
        <title>Top-left triangle</title>
        <polygon points="0,0 8,0 0,8" fill="currentColor" />
      </svg>
    </Motion>

    <!-- Top-right triangle -->
    <Motion
      tag="div"
      class="absolute top-0 right-0"
      :style="{ width: '8px', height: '8px' }"
      :initial="false"
      :animate="{
        x: isHovered ? move : 0,
        y: isHovered ? -move : 0,
      }"
      :transition="{ type: 'spring', stiffness: 400, damping: 24 }"
    >
      <svg
        width="8"
        height="8"
        class="fill-background"
        aria-label="Top-right triangle"
      >
        <title>Top-right triangle</title>
        <polygon points="8,0 8,8 0,0" fill="currentColor" />
      </svg>
    </Motion>

    <!-- Bottom-left triangle -->
    <Motion
      tag="div"
      class="absolute bottom-0 left-0"
      :style="{ width: '8px', height: '8px' }"
      :initial="false"
      :animate="{
        x: isHovered ? -move : 0,
        y: isHovered ? move : 0,
      }"
      :transition="{ type: 'spring', stiffness: 400, damping: 24 }"
    >
      <svg
        width="8"
        height="8"
        class="fill-background"
        aria-label="Bottom-left triangle"
      >
        <title>Bottom-left triangle</title>
        <polygon points="0,8 8,8 0,0" fill="currentColor" />
      </svg>
    </Motion>

    <!-- Bottom-right triangle -->
    <Motion
      tag="div"
      class="absolute right-0 bottom-0"
      :style="{ width: '8px', height: '8px' }"
      :initial="false"
      :animate="{
        x: isHovered ? move : 0,
        y: isHovered ? move : 0,
      }"
      :transition="{ type: 'spring', stiffness: 400, damping: 24 }"
    >
      <svg
        width="8"
        height="8"
        class="fill-background"
        aria-label="Bottom-right triangle"
      >
        <title>Bottom-right triangle</title>
        <polygon points="8,8 0,8 8,0" fill="currentColor" />
      </svg>
    </Motion>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
const { Motion } = defineAsyncComponent(() => import("motion-v"));

interface Props {
  isHovered: boolean;
  move?: number;
}

withDefaults(defineProps<Props>(), {
  move: -4,
});
</script>
